<template>
  <v-container
    class="display-bar-container"
    v-bind:style="{width: this.resultsContainerWidth - this.resultsSectionSourceCarouselWidth + 'px'}"
  >
    <v-layout row class="display-bar-row">
      <v-flex shrink class="display-bar-dropdown">
        <v-btn-toggle
            mandatory
            v-model="dropdownSelectedValue"
            class="display-bar-dropdown-btn-group"
            color="info"
        >
          <v-btn flat class="display-bar-dropdown-btn first-btn" value="Query String" :color="dropdownSelectedValue==='Query String' ? 'primary' : ''">
            <span>{{ $t('displayBar.queryString.title') }}</span>
          </v-btn>
          <v-btn flat class="display-bar-dropdown-btn second-btn" value="URL" :color="dropdownSelectedValue==='URL' ? 'primary' : ''">
            <span>{{ $t('displayBar.url.title') }}</span>
          </v-btn>
        </v-btn-toggle>
        <span class="first-divider-line display-bar-divider-line vertical-divider-line vertical-divider-line-blue"></span>
      </v-flex>
      <v-flex
        grow
        class="display-bar-box custom-scrollbar"
        v-bind:style="{maxWidth: this.resultsContainerWidth-170-157 + 'px'}"
      >
        <span
            class="display-bar-box-text"
            :class="!getShowUrl ? 'result-links-text-error-msg' : ''"
        >
          <span v-if="dropdownSelectedValue === 'URL'">
            {{ getTruncatedUrl }}
          </span>
          <span v-else-if="dropdownSelectedValue === 'Query String'">
            {{ getBooleanString }}
<!--            {{ this.$store.state.queryState.booleanString !== ''-->
<!--            ? this.$store.state.queryState.booleanString-->
<!--            : 'Your Query String will appear here'}}-->
          </span>
        </span>
      </v-flex>
      <v-flex class="display-bar-action">
        <button class="display-bar-action-btn" @click="onActionClick" :aria-label="dropdownSelectedValue === 'URL' ? 'Copy URL' : 'Copy Query String'">
          <v-icon class="icon-copy">content_copy</v-icon>
        </button>
        <span class="icon-copy-divider-line display-bar-divider-line vertical-divider-line vertical-divider-line-blue"></span>
        <button class="display-bar-action-btn display-bar-action-btn-new-tab" @click="$emit('newTabResults')" aria-label="Open Results in New tab">
          <v-icon class="icon-copy">open_in_new</v-icon>
        </button>
        <button class="display-bar-action-btn display-bar-action-btn-new-tab" @click="$emit('reloadResults')" aria-label="Open Results in New tab">
          <v-icon class="icon-copy">refresh</v-icon>
        </button>
<!--        <v-tooltip bottom>-->
<!--          <span slot="activator" @click="$emit('reloadResults')">-->
<!--            <v-icon class="icon-copy">refresh</v-icon>-->
<!--          </span>-->
<!--          <span>tooltip</span>-->
<!--        </v-tooltip>-->
      </v-flex>
    </v-layout>
<!--  Syntax Guide  -->
  </v-container>
</template>
<script>
import {resultsSectionSourceCarouselWidth} from '../../../utils/constants'
import { mapGetters } from 'vuex'
import '../../../style/_variables.scss'

export default {
  name: 'results-section-display-bar',
  props: ['targetEngine'],
  computed: {
    ...mapGetters(['getTruncatedUrl', 'getShowUrl', 'getBooleanString', 'getResultsURl']),
    resultsUrl: { get () { return this.$store.state.queryState.resultsUrl } },
    resultsContainerWidth: { get () { return this.$store.state.appState.resultsContainerWidth } }
  },
  data () {
    return {
      displayBarDropdownItems: ['Query String', 'URL'],
      dropdownSelectedValue: 'Query String',
      resultsSectionSourceCarouselWidth: resultsSectionSourceCarouselWidth
    }
  },
  methods: {
    onActionClick () {
      switch (this.dropdownSelectedValue) {
        case 'Query String':
          this.$emit('handleCopyClick', [this.getBooleanString, 'Query String'])
          break
        case 'URL':
          this.$emit('handleCopyClick', [this.resultsUrl, 'URL'])
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.display-bar {
  &-container {
    position: relative;
    background-color: $grey-400;
    padding: 10px 0;
    max-width: calc(100vw - #{$side-nav-width} - #{$side-nav-width} - 20px);
  }
  &-row {
    overflow: hidden;
    border-radius: $length-small-xl;
    height: 35px;
  }
  &-dropdown {
    display: flex;
    align-items: center;
    font-weight: bold;
    &-btn-group {
      display: flex;
      width: fit-content;
      margin-right: $length-small-m;
      border-radius: $length-med-xs;
    }
    &-btn {
      text-transform: capitalize;
      & > .btn__content {
        border-radius: 12px;
      }
    }
    &-btn-active {
      color: blue
    }
  }
  &-box {
    background-color: $bg-primary;
    border-radius: $length-med-xs;
    padding-left: $length-med-xs;
    text-overflow: ellipsis;
    overflow-x: scroll;
    overflow-y: hidden;
    &-text {
      line-height: 35px;
      white-space: nowrap;
      display: block;
      width: 100%;
      & > span {
        display: block;
        width: 100%;
      }
    }
  }
  &-action {
    display: flex;
    align-items: center;
    max-width: 75px;
    height: 35px;
    margin-left: 3px;
    margin-right: 2px;
    &-btn-new-tab {
      margin-left: 8px;
    }
  }
  &-divider-line {
    height: 20px;
    margin: 0 6px;
  }
}
.first-btn {
  padding-left: 4px;
}
.second-btn {
  padding: 0 4px;
}
.first-divider-line {
  margin-left: 1px;
}
.icon {
  &-copy {
    font-size: 18px;
    color: $black-900;
    &-divider-line {
      margin: 0 1px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/parts/ResultsContainer/ResultsSectionDisplayBar.vue